import { Endorsement } from '@accredible-frontend-v2/models';

export const TranscriptStatus = {
  TRANSCRIPT_GENERATING: 'transcript_generating',
  TRANSCRIPT_GENERATION_FAILED: 'transcript_generation_failed',
  TRANSCRIPT_GENERATED: 'transcript_generated',
  TRANSCRIPT_VIEWED: 'transcript_viewed',
  EMAIL_SENT: 'email_sent',
  EMAIL_FAILED: 'email_failed',
  EMAIL_BOUNCED: 'email_bounced',
  EMAIL_RECEIVED: 'email_received',
  EMAIL_DROPPED: 'email_dropped',
  EMAIL_OPENED: 'email_opened',
} as const;

export type TranscriptStatus = (typeof TranscriptStatus)[keyof typeof TranscriptStatus];

interface Issuer {
  id: number;
  name: string;
}

interface Group {
  id: number;
  name: string;
  description: string;
}

interface Credential {
  id?: number;
  uuid?: string;
  name: string;
  description: string;
  issuer: Issuer;
  recipient: {
    name: string;
  };
  group: Group;
  grade: string;
  issued_on: string;
  expired_on: string;
  url: string;
  endorsements: Endorsement[];
}

interface TranscriptContent {
  credentials: Credential[];
  legends: string[];
}

export type TranscriptCreateRequest = Pick<
  Transcript,
  | 'sender_name'
  | 'sender_email'
  | 'student_id'
  | 'receiver_name'
  | 'receiver_email'
  | 'receiver_kind'
  | 'application_number'
> & {
  sender_dob: string;
  credential_ids: number[];
};

export type TranscriptPreview = Pick<
  Transcript,
  | 'sender_name'
  | 'sender_email'
  | 'sender_dob'
  | 'receiver_name'
  | 'receiver_email'
  | 'receiver_kind'
  | 'student_id'
  | 'application_number'
  | 'generated_at'
  | 'content'
> & {
  id?: string;
  status?: TranscriptStatus;
};

export const TranscriptKind = {
  UNIVERSITY: 'university',
  EMPLOYER: 'employer',
  SELF: 'myself',
  OTHER: 'other',
} as const;

export type TranscriptKind = (typeof TranscriptKind)[keyof typeof TranscriptKind];

export interface Transcript {
  id: string;
  sender_name: string;
  sender_email: string;
  sender_dob: string;
  receiver_name: string;
  receiver_email: string;
  receiver_kind: TranscriptKind;
  student_id: string;
  application_number: string;
  generated_at: string;
  content: TranscriptContent;
  status: TranscriptStatus;
}

export interface TranscriptResponse {
  transcript: Transcript;
}
